import { $color, $shadow } from "@/utils/cssVarUtils"
import { popoverAnatomy as parts } from "@chakra-ui/anatomy"
import type {
  PartsStyleFunction,
  SystemStyleFunction,
  SystemStyleObject,
} from "@chakra-ui/theme-tools"
import { cssVar } from "@chakra-ui/theme-tools"
import { CloseButton } from "./close-button"

const $popperBg = cssVar("popper-bg")

const $arrowBg = cssVar("popper-arrow-bg")
const $arrowShadowColor = cssVar("popper-arrow-shadow-color")

const baseStylePopper: SystemStyleObject = {
  zIndex: 10,
}

const baseStyleContent: SystemStyleFunction = (props) => {
  return {
    [$popperBg.variable]: $color('bg-tooltip-accent'),
    bg: $popperBg.reference,
    [$arrowBg.variable]: $popperBg.reference,
    [$arrowShadowColor.variable]: $shadow('normal'),
    width: "container.md",
    border: "1px solid",
    borderColor: $color('scene-border'),
    borderRadius: "2xs",
    boxShadow: $shadow('normal'),
    zIndex: "inherit",
    _focusVisible: {
      outline: 0,
      boxShadow: '',
    },
    _focus: {
      boxShadow: '',
    }
  }
}

const baseStyleHeader: SystemStyleObject = {
  px: 'xs',
  py: '2xs',
  borderBottomWidth: "1px",
  borderBottomColor: $color('scene-border'),
}

const baseStyleBody: SystemStyleObject = {
  px: 'xs',
  py: '2xs',
}

const baseStyleFooter: SystemStyleObject = {
  px: 'xs',
  py: '2xs',
  borderTopWidth: "1px",
}

const baseStyleCloseButton: SystemStyleFunction = (props) =>{
  return {
    ...CloseButton.baseStyle(props),
    ...CloseButton.sizes.sm,
    top: '2xs',
    right: 'xs',
  }
}

const baseStyle: PartsStyleFunction<typeof parts> = (props) => ({
  popper: baseStylePopper,
  content: baseStyleContent(props),
  header: baseStyleHeader,
  body: baseStyleBody,
  footer: baseStyleFooter,
  arrow: {},
  closeButton: baseStyleCloseButton(props),
})

export const Popover = {
  parts: parts.keys,
  baseStyle,
}